var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListButton',{attrs:{"img-src":_vm.viewIcon ? '/icons/chevron-right.svg' : '/icons/edit.svg',"label":_vm.$t('buttonLabel'),"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }